import { useEffect, useState } from 'react';

/**
 * Retorna uma versão debounced de um valor.
 * Útil pra input de busca de tabelas (evita uma request por tecla).
 */
export function useDebouncedValue<T>(value: T, delayMs: number = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
